import { render, staticRenderFns } from "./canNotService.vue?vue&type=template&id=38fc3a9b&scoped=true&"
import script from "./canNotService.vue?vue&type=script&lang=js&"
export * from "./canNotService.vue?vue&type=script&lang=js&"
import style0 from "./canNotService.vue?vue&type=style&index=0&id=38fc3a9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc3a9b",
  null
  
)

export default component.exports